<template>
  <div class="popup-new" data-popup="popup-1" id="text_for_classification_popup">
    <div class="popup-inner">
      <!--CLOSE EVENT-->
      <a class="popup-close" data-toggle="modal" data-target="#text_for_classification_popup" href="#"><img src="../../assets/cross.png"></a>
      <select-text-popup
          type="text"
          class="text-selection-popup"
          v-if="popupShown" @cancel="popupShown = false"
          :text="testText"
          @select="setTestText($event.newText); popupShown = false"></select-text-popup>
      <!--Text for Classification INNER CONTENT-->
      <div class="txt-box">
        <div class="img-txt">
          <img style="vertical-align: top;" src="../../assets/Microscope-Outline-white1.png">
          <h2 class="white"><strong>Text for Classification:</strong> Select text for classification</h2>
          <div class="i-doc white float-left"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
        </div>
      </div>
      <div class="classes-area add">
        <div class="baron mybaron">
          <div id="scrollable12" class="baron__scroller" style="padding: 23px 0 10vh;">
            <h3>Select biblical text for classification</h3>
            <manage-text-control
                :text="testText"
                :placeholder-name="'Text for classification'"
                @show-select-text="showNoTextSelectedError = false; popupShown = true"
                :showTooFewClassesError = "showNoTextSelectedError"
                :context="'Text'"
            ></manage-text-control>

          </div>
          <div class="baron__track">
            <div class="baron__bar"></div>
          </div>
        </div>
      </div>
      <div class="tab-footer">
        <div class="tooltip-holder pull-right">
          <button type="button" class="button lg bg-blue pull-right hoverable analyze"
          @click="analyzeClicked()"><div class="anim"></div>Classify Text</button>
          <!--<div  class="tooltip error-tooltip"><p>You must select <br>a text</p></div>-->
          <div v-if="showNoTextSelectedError" id="no-text-selected-error-tooltip" class="tooltip error-tooltip" >
            <a class="canceltooltip" href="#" @click="showNoTextSelectedError = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
            <p>You must select <br>a text</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectTextPopup from './selectTextPopup'
import $ from 'jquery'
import textMixins from '../../mixins/textMixins'
import ManageTextControl from './manageTextControl'
import {StateChanges} from '../../store/stateChanges'
import {Text} from '../../texts'
import routeGlobals from '../../mixins/routeGlobals'

function gtag () { window.dataLayer.push(arguments) }

export default {
  name: 'textClassifyPopup',
  components: {ManageTextControl, SelectTextPopup},
  data () {
    return {
      popupShown: false,
      showNoTextSelectedError: false
    }
  },
  mixins: [textMixins, routeGlobals],
  methods: {
    openHelpTab () { // directories defined in routeGlobals
      window.open(this.helpRootDir + this.helpPagesSubDir + 'classify.htm')
    },
    analyzeClicked () {
      if (!this.testText.hasKeys()) {
        this.showNoTextSelectedError = true
        return
      }
      gtag('config', 'UA-103843509-5', {'page_path': 'classify-text'})
      this.analyze()
      $('#text_for_classification_popup').modal('hide')
    }
  },
  mounted () {
    if (!this.testText) {
      this.$store.commit(StateChanges.SET_TEST_TEXT, new Text())
    }
    const vm = this
    $('#text_for_classification_popup').on('hidden.bs.modal', function () {
      vm.popupShown = false
    })
  },
  beforeDestroy () {
    $('#text_for_classification_popup').modal('hide')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  #no-text-selected-error-tooltip {
    display: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/textClassificationPopup.vue